// ---------------------------------------------------------------------------
// Block Definition: heading (DocDsl)
//
// H1-H6 heading with level-based sizing.  LLM generates heading text from source.
// ---------------------------------------------------------------------------

const EVIDENCE_DESC = "Verbatim sentence(s) from the SOURCE that justify this value — quote exactly, do not paraphrase. If combining separate spans, join them with ' … '. null if not directly stated.";

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const headingDef = {
  type: "heading",
  label: "Heading",
  description: "Section heading (H1-H6) with automatic font sizing.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      const level = block.level || 1;
      const prompt = block.prompt || `Heading (H${level}) summarizing the section.`;
      const props = { text: nullable("string", prompt) };
      if (block.cite) props.text__evidence = nullable("string", EVIDENCE_DESC);
      return { type: "object", properties: props, required: Object.keys(props), additionalProperties: false };
    },

    buildShapeDescription(block) {
      const level = block.level || 1;
      return `{ "text": "<string>" }  // H${level} heading`;
    },

    isBlockLevelTarget() { return true; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "heading",
    category: "text",
    defaultTemplate: { type: "heading", level: 1 },
    configFields: [
      { name: "level", type: "select", label: "Level", options: ["1","2","3","4","5","6"], defaultValue: "1" },
      { name: "prompt", type: "string", label: "LLM prompt override" },
    ],
  },
};
